"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameExtranet = void 0;
var estiloFrameExtranet = require("./FrameExtranet.module.scss");
var react_1 = __importStar(require("react"));
var CabecalhoExtranet_1 = require("../CabecalhoExtranet/CabecalhoExtranet");
var Rodape_1 = require("../Rodape/Rodape");
var BarraNavegacao_1 = require("../BarraNavegacao/BarraNavegacao");
var FrameExtranet = function (_a) {
    var _b;
    var _c;
    var _d = _a.possuiIframe, possuiIframe = _d === void 0 ? false : _d, informacoesUsuario = _a.informacoesUsuario, notificacaoProps = _a.notificacaoProps, conteudoNotificacao = _a.conteudoNotificacao, tituloCabecalho = _a.tituloCabecalho, _e = _a.paginaAtual, paginaAtual = _e === void 0 ? 0 : _e, onLogout = _a.onLogout, onClickNotificacao = _a.onClickNotificacao, onClickSecao = _a.onClickSecao, children = _a.children;
    // refs
    var containerRef = (0, react_1.useRef)(null);
    var sentinelaRef = (0, react_1.useRef)(null);
    var rodapeRef = (0, react_1.useRef)(null);
    // estado da visibilidade do rodapé
    var _f = (0, react_1.useState)(false), rodapeVisivel = _f[0], setRodapeVisivel = _f[1];
    // altura medida do componente Rodape (varia por breakpoint)
    var _g = (0, react_1.useState)(60), alturaRodape = _g[0], setAlturaRodape = _g[1]; // valor seguro inicial
    // observa o fim do conteúdo **dentro** do container que rola
    (0, react_1.useEffect)(function () {
        var root = containerRef.current; // o seu .container com overflow-y: auto
        var alvo = sentinelaRef.current;
        if (!root || !alvo)
            return;
        var io = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            setRodapeVisivel(entry.isIntersecting);
        }, {
            root: root, // <- importante: observa dentro do container
            threshold: 1, // exige encostar MESMO no fim; use 0.95 se quiser antes
            // rootMargin: "0px 0px -64px 0px", // alternativa para antecipar
        });
        io.observe(alvo);
        return function () { return io.disconnect(); };
    }, []);
    // mede a altura do rodapé para ajustar o padding do conteúdo
    (0, react_1.useEffect)(function () {
        var medir = function () {
            if (rodapeRef.current) {
                var h = rodapeRef.current.offsetHeight;
                if (h && h !== alturaRodape)
                    setAlturaRodape(h);
            }
        };
        medir();
        // re-medir em resize (por causa do @media do seu Rodape)
        var onResize = function () { return medir(); };
        window.addEventListener("resize", onResize);
        return function () { return window.removeEventListener("resize", onResize); };
    }, [alturaRodape]);
    return (react_1.default.createElement("div", { ref: containerRef, className: "".concat(estiloFrameExtranet.container), 
        // injeta CSS var para o SCSS usar no padding-bottom do conteúdo
        style: (_b = {}, _b["--altura-rodape"] = "".concat(alturaRodape, "px"), _b) },
        react_1.default.createElement("div", { className: "".concat(estiloFrameExtranet.cabecalho, " ").concat(possuiIframe ? estiloFrameExtranet.cabecalhoIframe : "") },
            react_1.default.createElement(CabecalhoExtranet_1.CabecalhoExtranet, { titulo: tituloCabecalho, informacoesUsuario: informacoesUsuario, onClickNotificacao: onClickNotificacao, notificacaoProps: {
                    tipo: "numero",
                    estado: (_c = notificacaoProps === null || notificacaoProps === void 0 ? void 0 : notificacaoProps.estado) !== null && _c !== void 0 ? _c : "infoNeutral",
                    conteudoNotificacao: conteudoNotificacao,
                }, onLogout: onLogout }),
            react_1.default.createElement(BarraNavegacao_1.BarraNavegacao, { onClick: onClickSecao, paginaAtual: paginaAtual })),
        react_1.default.createElement("div", { className: "".concat(estiloFrameExtranet.conteudo, " ").concat(possuiIframe ? estiloFrameExtranet.conteudoIframe : "") },
            children,
            react_1.default.createElement("div", { ref: sentinelaRef, className: estiloFrameExtranet.sentinela, "aria-hidden": true })),
        react_1.default.createElement("div", { ref: rodapeRef, className: "".concat(estiloFrameExtranet.rodape, " ").concat(rodapeVisivel ? estiloFrameExtranet.visivel : "") },
            react_1.default.createElement(Rodape_1.Rodape, null))));
};
exports.FrameExtranet = FrameExtranet;
